<skl-dialog-content-ins [isReady]="viewModel?.isReady">
	<skl-dialog-header-ins
		[title]="'scenes.accountancy.service.dialog.data-exchange-errors-and-warnings.title' | translate"
		id="accountancy-data-exchange-errors-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<div class="align--form">
			<skl-grid-ins
				[displayHeaders]="false"
				id="accountancy-data-exchange-errors-dialog-grid"
				[dataSource]="viewModel.gridDataSource$"
				[columns]="viewModel.gridColumns$"
				[options]="viewModel.gridOptions">
			</skl-grid-ins>
		</div>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="accountancy-data-exchange-errors-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.accountancy.service.dialog.data-exchange-errors-and-warnings.buttons.close' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>